import { render, staticRenderFns } from "./CrewFamily.vue?vue&type=template&id=99d724ca&scoped=true&"
import script from "./CrewFamily.vue?vue&type=script&lang=js&"
export * from "./CrewFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d724ca",
  null
  
)

export default component.exports